export const switchLayerReduce = (state, action) => {
  switch (action) {
    case "TOGGLE_FIRE":
      if (state.isFireOn) return { ...state, isFireOn: false };

      if (state.isEffisOn) return { ...state, isFireOn: true, isEffisOn: false };

      return { ...state, isFireOn: !state.isFireOn };
    case "TOGGLE_EFFIS":
      if (state.isEffisOn) return { ...state, isEffisOn: false };

      if (state.isFireOn) return { ...state, isEffisOn: true, isFireOn: false };

      return { ...state, isEffisOn: !state.isEffisOn };
    case "TOGGLE_SATELLITE":
      return { ...state, isSatellite: !state.isSatellite };
    default:
      return state;
  }
}